import React from 'react'
import {FormatNumber} from "../../helpers/Helpers";
import Card from "@material-ui/core/Card";

class PaymentsList extends React.Component {

    render() {

        const {data} = this.props;

        return (
            <Card>
                <table className='custom-table'>
                    <thead>
                    <tr>
                        <th colSpan={3}>Últimos pagos</th>
                    </tr>
                    <tr>
                        <th>Banco</th>
                        <th>Fecha</th>
                        <th>Valor ($)</th>
                    </tr>
                    </thead>
                    <tbody>

                    {data.map((val, index) => {
                        return (
                            <tr key={index}>
                                <td>{val.BANCO}</td>
                                <td>{val.FECHA_PAGO}</td>
                                <td>$ {FormatNumber.new(val.VALOR_PAGO)}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </Card>
        );
    }
}

export default PaymentsList